import asyncActionTypes from '../actions/types.js';

const initialState = {
  brandedBenefits: [],
  loadingBrandedBenefits: false,
};

const brandedBenefits = (state = initialState,  action = null / undefined) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CMS_BRANDED_BENEFITS.START:
      return {
        ...state,
        loadingBrandedBenefits: true,
        brandedBenefits: initialState.brandedBenefits,
      };
    case asyncActionTypes.RETRIEVE_CMS_BRANDED_BENEFITS.SUCCESS:
      return {
        ...state,
        loadingBrandedBenefits: false,
        brandedBenefits: action.payload,
      };
    case asyncActionTypes.RETRIEVE_CMS_BRANDED_BENEFITS.FAIL:
      return {
        ...state,
        loadingBrandedBenefits: false,
      };
    default:
      return state;
  }
};

export default brandedBenefits;